import { render, staticRenderFns } from "./uvLight.vue?vue&type=template&id=147b71e6&"
import script from "./uvLight.vue?vue&type=script&lang=js&"
export * from "./uvLight.vue?vue&type=script&lang=js&"
import style0 from "./uvLight.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports